import resolveConfig from 'tailwindcss/resolveConfig';

// @ts-ignore
import config from '../../tailwind.config';

export const twConfig = resolveConfig(config);
